/* Written by Stuart. */
( function( factory ) {
    if ( typeof define === "function" && define.amd ) {

        // AMD. Register as an anonymous module.
        define( [ "../widgets/datepicker" ], factory );
    } else {

        // Browser globals
        factory( jQuery.datepicker );
    }
}( function( datepicker ) {

    datepicker.regional[ "en-GB" ] = {
        closeText: "Done",
        prevText: "Prev",
        nextText: "Next",
        currentText: "Today",
        monthNames: [ "January","February","March","April","May","June",
            "July","August","September","October","November","December" ],
        monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ],
        dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
        dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
        dayNamesMin: [ "Su","Mo","Tu","We","Th","Fr","Sa" ],
        weekHeader: "Wk",
        dateFormat: "dd/mm/yy",
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: "" };
    datepicker.setDefaults( datepicker.regional[ "en-GB" ] );

    return datepicker.regional[ "en-GB" ];

} ) );

$(document).ready( function() {
$( "#datepicker" ).datepicker( $.datepicker.regional[ "en" ] );
$( "#datepicker" ).datepicker( $.datepicker.regional[ "de" ] );
$( "#datepicker" ).datepicker( $.datepicker.regional[ "nl" ] );
$( "#datepicker" ).datepicker( $.datepicker.regional[ "fr" ] );


  $("#datepicker").datepicker({    
  beforeShowDay: function(date) {
        var day = date.getDay();
        return [(day != 0), ''];
    }
    
});
  
   $(this).datepicker($.extend({}, $.datepicker.regional['fr'], {
  changeMonth: true,
  changeYear: true
}));




});